import { render } from "./EntraIDLoginButton.vue?vue&type=template&id=5d71466b"
import script from "./EntraIDLoginButton.vue?vue&type=script&lang=js"
export * from "./EntraIDLoginButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__